import AdminProfile from "./AdminProfile";
import Layout from "../../components/Layout/Layout";
// import UserProfile from "./UserProfile";
// import Box from "@mui/material/Box";
// import useStyles from "./styles";

const Profile = () => {
  return (
    <Layout children={
      <>
        <AdminProfile />
      </>
    }
    />
  );
};

export default Profile;
